import React, { useState } from 'react';
import fremtidensmad from '../../images/mili.jpg';  // Import the image
import { useNavigate } from 'react-router-dom';

const stockSymbols = [
  { symbol: 'SAAB-B.ST', name: 'SAAB B' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'BA', name: 'Boeing' }, // NYSE (US)
  { symbol: 'LMT', name: 'Lockheed Martin' }, // NYSE (US)
  { symbol: 'W5.ST', name: 'W5 Solutions' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'RHM.DE', name: 'Rheinmetall AG' }, // XETRA (Germany)
  { symbol: 'NOC', name: 'Northrop Grumman' }, // NYSE (US)
  { symbol: 'GD', name: 'General Dynamics' }, // NYSE (US)
  { symbol: 'DRS', name: 'Leonardo DRS' }, // NASDAQ (US)
  { symbol: 'ACHR', name: 'Archer Aviation A' }, // NYSE (US)
  { symbol: 'BA.L', name: 'BAE Systems PLC' }, // London Stock Exchange (UK)
  { symbol: 'AXON', name: 'Axon Enterprise' }, // NASDAQ (US)
  { symbol: 'SWBI', name: 'Smith & Wesson Brands' }, // NASDAQ (US)
  { symbol: 'AVAV', name: 'AeroVironment' }, // NASDAQ (US)
  { symbol: 'LHX', name: 'L3Harris Technologies' }, // NYSE (US)
  { symbol: 'RGR', name: 'Sturm Ruger & Co' }, // NYSE (US)
  { symbol: 'HII', name: 'Huntington Ingalls Industries' }, // NYSE (US)
  { symbol: 'HAG.DE', name: 'Hensoldt AG' }, // XETRA (Germany)
  { symbol: 'KTOS', name: 'Kratos Defense & Security Solutions' }, // NASDAQ (US)
  { symbol: 'MTX.DE', name: 'MTU Aero Engines AG' }, // XETRA (Germany)
  { symbol: 'POWW', name: 'AMMO' }, // NASDAQ (US)
  { symbol: 'ESLT', name: 'Elbit Systems' }, // NASDAQ (US)
  { symbol: 'ERJ', name: 'Embraer ADR' }, // NYSE (US)
  { symbol: 'HEI', name: 'Heico' }, // NYSE (US)
  { symbol: 'TXT', name: 'Textron' }, // NYSE (US)
  { symbol: 'EVEX', name: 'Eve Holding' }, // NYSE (US)
  { symbol: 'SPR', name: 'Spirit Aerosystems' }, // NYSE (US)
  { symbol: 'AIRI', name: 'Air Industries Group' }, // NYSE American (US)
  { symbol: 'TDG', name: 'Transdigm Group' }, // NYSE (US)
  { symbol: 'CODA', name: 'Coda Octopus' }, // NASDAQ (US)
  { symbol: 'PSN', name: 'Parsons' }, // NYSE (US)
  { symbol: 'CAE', name: 'Cae' }, // NYSE (US)
  { symbol: 'VVX', name: 'V2X' }, // NYSE (US)
  { symbol: 'AIR', name: 'AAR' }, // NYSE (US)
  { symbol: 'BYRN', name: 'Byrna Technologies' }, // NASDAQ (US)
  { symbol: 'MG', name: 'Mistras Group' }, // NYSE (US)
  { symbol: 'WWD', name: 'Woodward' }, // NASDAQ (US)
  { symbol: 'TGI', name: 'Triumph Group' }, // NYSE (US)
  { symbol: 'ISSC', name: 'Innovative Solutions and Support' }, // NASDAQ (US)
  { symbol: 'TATT', name: 'TAT Technologies' }, // NASDAQ (US)
  { symbol: 'NPK', name: 'National Presto Industries' }, // NYSE (US)
  { symbol: 'ATRO', name: 'Astronics' }, // NASDAQ (US)
  { symbol: 'CDRE', name: 'Cadre' }, // NYSE (US)
  { symbol: 'VSEC', name: 'VSE' }, // NASDAQ (US)
  { symbol: 'RTX', name: 'RTX' }, // NYSE (US)
  { symbol: 'KOG.OL', name: 'Kongsberg Gruppen' }, // Oslo Børs (Norway)
]




function FintechCard15() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [stocks, setStocks] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleCardClick = async () => {
    setLoading(true);
    setIsModalOpen(true);
    try {
      const symbolsToFetch = stockSymbols.map(stock => stock.symbol);
      console.log('Fetching symbols:', symbolsToFetch);

      const stockPromises = symbolsToFetch.map(async symbol => {
        try {
          const response = await fetch(`https://investorverden.onrender.com/api/stocks?q=${symbol}`);
          if (!response.ok) throw new Error(`Failed to fetch ${symbol}`);
          return await response.json();
        } catch (error) {
          return { error: `Symbol failed: ${symbol}` };
        }
      });

      const results = await Promise.all(stockPromises);
      console.log('Raw results:', results);

      const processedStocks = results.map(result => {
        // If there's an error property
        if (result.error) {
          return {
            logo: '',
            name: result.error,
            price: '-',
            changePercent24h: '-',
            isPositive: false,
            marketCap: '-',
            currency: '-',
          };
        }
        const { stockData: sd } = result;
        if (!sd) {
          return {
            logo: '',
            name: 'No data',
            price: '-',
            changePercent24h: '-',
            isPositive: false,
            marketCap: '-',
            currency: '-',
          };
        }
        const matchingSymbol = stockSymbols.find(s => s.symbol === sd.symbol);
        return {
          logo: sd.logo_url || '',
          name: matchingSymbol?.name || sd.shortName || sd.symbol,
          price: sd.regularMarketPrice?.toFixed(2) || '0.00',
          changePercent24h: sd.regularMarketChangePercent?.toFixed(2) || '0.00',
          isPositive: parseFloat(sd.regularMarketChangePercent) > 0,
          marketCap: sd.marketCap
            ? (sd.marketCap / 1000000000).toFixed(2) + 'B'
            : 'N/A',
          currency: sd.currency || 'USD',
        };
      });

      console.log('Processed stocks:', processedStocks);
      setStocks(processedStocks);
    } catch (error) {
      console.error('Error:', error);
      setStocks([]);
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <div
        className="flex flex-col col-span-full sm:col-span-6 xl:col-span-3 bg-white dark:bg-gray-800 shadow-sm rounded-xl cursor-pointer"
        onClick={handleCardClick}
      >
        <div className="px-5 pt-5">
          <header>
            <h3 className="text-sm font-semibold text-gray-500 uppercase mb-1">
              <span className="text-gray-800 dark:text-gray-100">Forsvarsindustri</span>
            </h3>
          </header>
        </div>
        <div className="grow">
          <img src={fremtidensmad} alt="Fremtidens mad" className="w-full h-auto rounded-b-xl" />
        </div>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
          <div
            className="bg-white dark:bg-gray-800 p-5 rounded-lg shadow-lg w-full max-w-4xl"
            style={{ maxHeight: '80vh', overflowY: 'auto' }}
          >
            <h2 className="text-l font-semibold mb-4">Forsvarsindustri</h2>
            <p className="text-sm text-gray-700 dark:text-gray-200">
            Børsnoterede selskaber, som er baseret på forsvarsindustrien og militære tjenester.
              <br />
            </p>
            {loading ? (
              <div className="flex justify-center items-center h-48">
                <svg
                  className="animate-spin h-10 w-10 text-violet-500"
                  xmlns="http://www.w3.org/2000/svg"  
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v8H4z"
                  ></path>
                </svg>
              </div>
            ) : (
              <table className="w-full text-left">
                <thead>
                  <tr className="border-b">
                    <th className="px-2 py-1">Logo</th>
                    <th className="px-2 py-1">Selskab</th>
                    <th className="px-2 py-1">I dag</th>
                    <th className="px-2 py-1">Børsværdi</th>
                  </tr>
                </thead>
                <tbody>
                  {stocks.map((stock, index) => (
                    <tr key={index} className="border-b">
                      <td className="px-2 py-2">
                        {stock.logo ? (
                          <img src={stock.logo} alt={stock.name} className="w-6 h-6" />
                        ) : (
                          <span>N/A</span>
                        )}
                      </td>
                      <td className="px-2 py-2">
                        {stock.name}: {stock.currency}
                      </td>
                      <td
                        className={`px-2 py-2 ${
                          stock.isPositive ? 'text-green-500' : 'text-red-500'
                        }`}
                      >
                        {stock.changePercent24h}%
                      </td>
                      <td className="px-2 py-2">{stock.marketCap}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            <button
              className="mt-4 px-4 py-2 bg-violet-500 text-white rounded"
              onClick={closeModal}
            >
              Luk
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default FintechCard15;